<template>
  <v-card
    class="secondary--text mt-8 pa-8"
    style="box-shadow: 15px 15px 40px #00000029;border-radius: 20px;"
  >
    <v-card-title class="pa-0 mb-6">
      <div class="ml-2">
        Order Details
      </div>
    </v-card-title>
    <div
      v-for="item in orderDetails.items"
      :key="item.id"
    >
      <div class="order-details ml-2 mb-3">
        <div class="d-flex justify-space-between align-center">
          <p
            class="font-weight-medium mb-0"
            style="cursor: pointer"
            @click="$router.push(`/verified-complaint/${$route.params.id}/order-details`)"
          >
            Order #{{ orderDetails.orderNumber }}
          </p>
          <p class="font-weight-medium mb-0">
            <!-- ${{ item.cost.toFixed(2) }} -->
            ${{ costSum(orderDetails.items) }}
          </p>
        </div>
        <div class="d-flex justify-space-between align-center">
          <p
            class="mb-0"
            style="color: #53809D; font-size: 16px;"
          >
            {{ item.title }}
          </p>
          <p
            class="mb-0"
            style="font-size: 16px;"
          >
            {{ $dayjs(date).format('MM.DD.YYYY') }}
          </p>
        </div>
      </div>
      <hr
        class="mb-2"
        style="border: 1px solid #DAE3E9;"
      >
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OrderDetailsCard',
  props: {
    date: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      orderDetails: "eviction/orderDetails"
    })
  },
  methods: {
    costSum(items) {
      let sum = 0;

      for (let i = 0; i < items.length; i++) {
        sum += items[i].cost;
      }

      return sum.toFixed(2);
    }
  } 
}
</script>

<style>

</style>